import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import { SearchParams } from 'src/state/SearchParams';

export function* updateQueryString({ query, section }: SearchParams): SagaIterator {
    if (!query) {
        yield put(replace('?'));
    } else if (!section) {
        yield put(replace(`?query=${encodeURIComponent(query)}`));
    } else {
        yield put(replace(`?query=${encodeURIComponent(query)}&section=${encodeURIComponent(section)}`));
    }
}
